module.exports = __webpack_public_path__ + "img/BJYX_common.b0715dab.png";